module.exports = __webpack_public_path__ + "img/breweries.3cd7b36c.jpg";